/* eslint-disable react/prop-types */
import React from 'react';

import ManualProfile from '@/assets/images/help/ManualProfile.png';
import Diagram from '@/components/diagram/Diagram';
import * as APPDATA from '@/constants/pcConstAppData';

import './ManualProfileHelp.less';

export function Content(props) {
  const {content} = props;
  const style = {
    constraint: {
      width: '100%',
      height: 360,
      display: 'grid',
    },
  };
  return <div style={style.constraint}>{content}</div>;
}

export function PageImageContent(props) {
  const {text, image} = props;
  return (
    <div className="row center">
      <div className="col-md-6">{image}</div>
      <div className="col-md-6">{text}</div>
    </div>
  );
}

export function CycleContent(props) {
  const {text, image} = props;
  return (
    <div className="row center">
      <div className="col-md-4 pictImage">{image}</div>
      <div className="col-md-8">{text}</div>
    </div>
  );
}

export const DataHelp = [
  {
    Title: `${APPDATA.MANUAL_PROFILE} Help`,
    Content: (
      <Content
        content={
          <div className="Page1">
            <center className="pageWithPict">
              Welcome to the <b>{APPDATA.MANUAL_PROFILE}</b> menu where you can directly run your sequence without
              having to create a profile. This method doesn’t track volume, it runs off timings input by the user.
            </center>
            <br />
            <ul type="square">
              <li>
                Cycles can be run in ‘Pumps’ or ‘Minutes’, This will run the cycle for the selected number of iterations
                or the amount of time before moving on to the next cycle in the list.
              </li>
              <li>
                The list of cycles can be repeated to allow for simplier control of longer concentration and/or buffer
                exchange sequences.
              </li>
              <li>Save your list of cycles before running a profile and/or apply them for future use.</li>
            </ul>
          </div>
        }
      />
    ),
  },
  {
    Title: 'Save Manual Profile',
    Content: (
      <Content
        content={
          <PageImageContent
            text={
              <>
                <center className="pageWithPict leftBorderYellow">Use to add new cycle card.</center>
                <center className="pageWithPict">
                  <br />
                </center>
                <center className="pageWithPict leftBorderCyan2">Use to load and/or rename the saved sequence.</center>
                <center className="pageWithPict">
                  <br />
                </center>
                <center className="pageWithPict leftBorderRed">Use to save the sequence you’ve created.</center>
              </>
            }
            image={
              <img
                src={ManualProfile}
                alt={ManualProfile}
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: 'Priming Cycle',
    Content: (
      <Content
        content={
          <CycleContent
            text={
              <div>
                <center className="pageWithPict">
                  The system will fill the filter chip with liquid from the buffer tube (right) to clear most of the air
                  from the liquid paths.
                  <br />
                  <br />
                  The default diaphragm pressure is set to low to best remove air and reduce bubbles.
                </center>
              </div>
            }
            image={
              <Diagram
                isPaused={false}
                isRunning
                currentState={Diagram.STATUS.PRIMING}
                scaleSize="medium"
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: 'Concentrating Cycle',
    Content: (
      <Content
        content={
          <CycleContent
            text={
              <div>
                <center className="pageWithPict">
                  The sample (left tube) will be pumped across the membrane to be concentrated by tangential flow
                  filtration.
                  <br />
                  <br />
                </center>
                <center className="AllFontPage">
                  The sample will circulate back into the sample tube to mix with the bulk sample.
                  <br />
                  <br />
                </center>
                <center className="AllFontPage">
                  The default diaphragm pressure is set to high for best concentration speed.
                </center>
              </div>
            }
            image={
              <Diagram
                isPaused={false}
                isRunning
                currentState={Diagram.STATUS.CONCENTRATING}
                scaleSize="medium"
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: 'Buffer Exchange Cycle',
    Content: (
      <Content
        content={
          <CycleContent
            text={
              <div>
                <center className="pageWithPict">
                  Buffer solution (right tube) will be pumped into the sample tube (left) to dilute the sample for
                  diafiltration or buffer exchange. This cycle only adds liquid to the sample so it must be used in
                  conjuction with Concentrating.
                  <br />
                  <br />
                  Concentrating doesn&apos;t remove liquid as fast as Buffer Exchange adds it, thus a ratio of at least
                  2:1 Concentrating to Buffer Exchange is needed to maintain or reduce volume level. It is best to test
                  the ratio of Concentrating to Buffer Exchange before leaving the system to run for an extend period of
                  time.
                </center>
              </div>
            }
            image={
              <Diagram
                isPaused={false}
                isRunning
                currentState={Diagram.STATUS.DIAFILTRRATING}
                scaleSize="medium"
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: 'Air Recovery Cycle',
    Content: (
      <Content
        content={
          <CycleContent
            text={
              <div>
                <center className="pageWithPict">
                  The system uses air from the buffer tube (right) to push liquid remaining in the chip back into the
                  sample tube for the liquid recovery. Make sure your liquid level in the tubes is below the short
                  tubing so that µPULSE can use the air.
                  <br />
                  <br />
                  This cycle is best run as the final step before removal of the sample from the system, but Buffer
                  Recovery can be used before it to maximize retention of sample.
                </center>
              </div>
            }
            image={
              <Diagram
                isPaused={false}
                isRunning
                currentState={Diagram.STATUS.RECOVERING_AIR}
                scaleSize="medium"
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: 'Buffer Recovery Cycle',
    Content: (
      <Content
        content={
          <CycleContent
            text={
              <div>
                <center className="pageWithPict">
                  The system uses buffer solution from the buffer (right) tube to push liquid through the chip to
                  recover sample from channel walls into the sample (right) tube.
                  <br />
                  <br />
                  This cycle will dilute your sample but will give the best sample retention. Air recovery can follow to
                  maximize sample volume recovery.
                </center>
              </div>
            }
            image={
              <Diagram
                isPaused={false}
                isRunning
                currentState={Diagram.STATUS.REVOCERING_BUFFFER}
                scaleSize="medium"
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: 'Tube Mixing',
    Content: (
      <Content
        content={
          <CycleContent
            text={
              <div>
                <center className="pageWithPict">
                  Tube Mixing recirculates samples to help maintain sample uniformity.
                </center>
              </div>
            }
            image={
              <Diagram
                isPaused={false}
                isRunning
                currentState={Diagram.STATUS.CONCENTRATING}
                scaleSize="medium"
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: 'Recirculation',
    Content: (
      <Content
        content={
          <CycleContent
            text={
              <div>
                <center className="pageWithPict">
                  Recirculation aspirates sample liquid in the tube to prevent build up on the surface of the membrane.
                </center>
              </div>
            }
            image={
              <Diagram
                isPaused={false}
                isRunning
                currentState={Diagram.STATUS.CONCENTRATING}
                scaleSize="medium"
              />
            }
          />
        }
      />
    ),
  },
];
